import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import * as links from '../../lib/links';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewAlert = ({
  deckId
}) => /*#__PURE__*/_jsx(Alert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "view.previewAlert.title"
  }),
  type: "warning",
  marginBlockEnd: "0",
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "view.previewAlert.description",
    options: {
      documentSummaryLink: /*#__PURE__*/_jsx(Link, {
        href: links.getSummaryPageURL(deckId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.previewAlert.documentSummaryLink"
        })
      })
    }
  })
});
export default PreviewAlert;